<template>
    <div class="wrapper">
        <div class="columns is-tablet">
            <div class="column is-12-mobile is-9-tablet p-l-150-fullhd p-r-150-fullhd">
                <h1 class="is-size-3 m-b-30 m-l-15">😑 Sorry, this page had to be removed</h1>
                <h3>What next?…	</h3>
                <ul class="m-l-60 m-t-15">
                    <li class="m-t-15">֎ <router-link :to="{path:'/contact'}">Contact us</router-link> to report the missing page</li>
                    <li class="m-t-15">֎ Search & compare funds <router-link :to="{path:'/?anchor=search-funds-section'}">here</router-link></li>
                    <li class="m-t-15">֎ View the <router-link :to="{path:'/?anchor=top-performing'}">top performing funds</router-link></li>
                    <li class="m-t-15">֎ Check out our <router-link :to="{path:'/blog'}">blog</router-link></li>
                    <li class="m-t-15">֎ Read <router-link :to="{path:'/about'}">our story</router-link></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'Page404',
  components: {
  },
    metaInfo() {
        return {
            title: "404 Page Not Found | Pickafund",
        }
    }
}
</script>
<style lang="scss" scoped>
a {
    text-decoration: underline;
}
</style>